import React, { useState } from "react";
import { Card, CardBody, Collapse, Button, Col } from "reactstrap";
import { ChevronDown, ChevronUp } from "lucide-react";
import CollapsibleSection from "./CollapsibleSection";
import DevicesTable from "./DevicesTable";

const SiteSettingsSection = ({ site, steeringPrefs, marketContext, electricalSystem, devices, onEdit }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Col md={10} className="mb-5">
      <Card className="mb-4 border-lt shadow-lg">
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">
              <strong>{site.display_name}</strong>
            </h6>
            <Button onClick={() => setIsOpen(!isOpen)} className="dropdown-toggle-btn">
              {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
            </Button>
          </div>

          <Collapse isOpen={isOpen}>
            <CollapsibleSection
              title="Steering Preferences for OptiSchedule"
              items={steeringPrefs}
              editable={steeringPrefs !== null ? true : false}
              onEdit={steeringPrefs !== null ? onEdit : {}}
              children={<div className="text-muted">No OptiSchedule for this site.</div>}
            />
            <CollapsibleSection title="Market Context" items={marketContext} children={<div className="text-muted">No Market Context for this site.</div>} />
            <CollapsibleSection title="Electrical System" items={electricalSystem} children={<div className="text-muted">No Electrical System for this site.</div>} />
            <CollapsibleSection title="Devices" children={<DevicesTable devices={devices} />} />
          </Collapse>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SiteSettingsSection;
